import defer from '../utils/defer';
/**
 * @ngdoc service
 * @name proximus.core.entity:JwtService
 * @description
 * # JwtService
 * Manages jwt headers for entities.
 */
export default class JwtService {
    constructor(configurationService, storage, platformService) {
        this.configurationService = configurationService;
        this.storage = storage;
        this.platformService = platformService;
    }
    // NOTE: now this method is using configuration service getJwtStorageStrategy
    addJwtHeaders(entity, headers) {
        const deferred = defer();
        const promises = [];
        if (entity.requiredJwts) {
            entity.requiredJwts.forEach(requiredJwt => {
                const jwtIdentifier = requiredJwt.replace(/\{identifier\}/, entity.identifier);
                const promise = this.storage.getItem(jwtIdentifier, this.configurationService.getJwtStorageStrategy());
                promise
                    .then(jwtValue => {
                    const jwtKey = requiredJwt.replace(/\{identifier\}/, '');
                    headers[jwtKey] = jwtValue;
                })
                    .catch(error => {
                    console.error('Error getting JWT header: ', error);
                });
                promises.push(promise);
            });
        }
        const suppress = x => {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return x.catch(() => { });
        };
        Promise.all(promises.map(suppress)).then(() => {
            deferred.resolve(headers);
        });
        return deferred.promise;
    }
}
